import React, { useMemo, useState, useEffect } from 'react';
import {
  Container, Row, Col,
} from 'reactstrap';
import classnames from 'classnames';

import {
  Intl, Form, TextField, Select, FormItemRow, FormActionsBtns,
} from 'components';
import { required } from 'config/InputErrors';
import {getCountries, isCountryUE, getCCAA,
   /* isCcaaUE, */
  } from 'utils';

export default ( {
  data, isLoading, parentPath, locale, onSubmit,
} ) => {
  const [countryId, setCountryId] = useState( '' );
  const [ccaaId, setCcaaId] = useState( '' );
  const [showVAT, setShowVAT] = useState( false );


  useEffect( () => {
    if ( data && data.id ) {
      if ( data.country ) {
        setCountryId( data.country );
      }
      if ( data.ccaa ) {
        setCcaaId( data.ccaa );
      }
    }
  }, [data] );

  useEffect( () => {
    let isShowVAT = false;
    if ( countryId === 'ES' ) {
      isShowVAT = false;// isCcaaUE( ccaaId );
    } else {
      isShowVAT = isCountryUE( countryId );
    }
    setShowVAT( isShowVAT );
  }, [countryId, ccaaId, setShowVAT] );

  return (
    <Container
      fluid
      className={classnames( { 'app-component-loading': isLoading } )}
    >
      <Form
        initialValues={data}
        showErrorsInHeader
        onSubmit={onSubmit}
        body={() => (
          <>
            <Row className="mb-1">
              <Col>
                <Intl id="fiscalData" />
              </Col>
            </Row>
            <FormItemRow
              title="companyName"
              field={(
                <TextField
                  field="fiscalName"
                  formGroupClass="m-0"
                  validate={required}
                />
              )}
            />
            <FormItemRow
              title="address"
              field={(
                <TextField
                  field="address"
                  formGroupClass="m-0"
                  validate={required}
                />
              )}
            />
            <FormItemRow
              title="postalCode"
              field={(
                <TextField
                  field="postalCode"
                  formGroupClass="m-0"
                  validate={required}
                />
              )}
            />
            <FormItemRow
              title="city"
              field={(
                <TextField
                  field="city"
                  formGroupClass="m-0"
                  validate={required}
                />
              )}
            />
            <FormItemRow
              title="country"
              field={(
                <Select
                  field="country"
                  formGroupClass="m-0"
                // eslint-disable-next-line.
                options={useMemo( () => getCountries( locale ), [locale] )}
                  validate={required}
                  onChange={( v ) => { setCountryId( v ); }}
                />
              )}
            />
            {countryId === 'ES' && (
            <FormItemRow
              title="ccaa"
              field={(
                <Select
                  field="ccaa"
                  formGroupClass="m-0"
                // eslint-disable-next-line
                options={getCCAA( )}
                  validate={required}
                  onChange={( v ) => { setCcaaId( v ); }}
                />
              )}
            />
            )}
            {showVAT && (
            <FormItemRow
              title="iva2"
              field={(
                <TextField
                  field="vat"
                  formGroupClass="m-0"
                />
              )}
            />
            )}


{
              countryId === 'ES' &&  (<FormItemRow
                title="taxId"
                field={(
                  <TextField
                    field="identificationNumber"
                    formGroupClass="m-0"
                    validate={required}
                    defaultValue="Small"
                  />
                  )}
              />   )
            }

            {
             countryId !== 'ES' && (
              <FormItemRow
            title="taxId"
            field={(
              <TextField
                field="identificationNumber"
                formGroupClass="m-0"
                // validate={required}
              />
              )}
          />
             ) 
            }
          </>
        )}
        footer={( <FormActionsBtns saveLabel="save" cancelTo={parentPath} /> )}
      />
    </Container>
  );
};
